module.exports = __webpack_public_path__ + "static/media/icon-report-student-report.d0b4f011.svg";